import React, {
  useState,
  useEffect,
  memo,
  useCallback,
  useContext,
} from "react";
import { withStyles } from "@material-ui/core/styles";

import AuditTable from "./components/AuditTable";
import Filters from "./components/Filters";

import ModalDialogContext from "../../../../Context/ModalDialog/ModalDialogContext";
import { getEntityAuditRecords } from "../../../../API/Audit";
import styles from "./styles";

const Audit = (props) => {
  const { classes, entityId } = props;
  const { showErrorMessage } = useContext(ModalDialogContext);

  const [auditRecords, setAuditRecords] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(30);
  const [loading, setLoading] = useState(true);

  const loadData = async (filters) => {
    try {
      setLoading(true);
      const result = await getEntityAuditRecords({
        ...filters,
        pageNumber,
        rowsPerPage: pageSize,
        entityId: parseInt(entityId),
      });
      const { records = [], count } = result.data || {
        records: [],
        count: 0,
      };
      setAuditRecords(records);
      setTotalItems(count);
      setLoading(false);
    } catch (error) {
      showErrorMessage({ error });
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData({
      pageNumber,
      pageSize,
    });
  }, [pageNumber, pageSize]);

  const handleFilterChange = useCallback(
    (filters) => {
      loadData(filters);
    },
    [setLoading]
  );

  const handlePageChange = useCallback(
    (pageNumber) => {
      setPageNumber(pageNumber);
    },
    [setPageNumber]
  );

  const handlePageSizeChange = useCallback(
    (pageSize) => {
      setPageSize(pageSize);
    },
    [setPageSize]
  );

  return (
    <div className={classes.pageContent}>
      <Filters handleFilterChange={handleFilterChange} />
      <AuditTable
        records={auditRecords}
        handlePageSizeChange={handlePageSizeChange}
        rowsPerPage={pageSize}
        pageNumber={pageNumber}
        handlePageChange={handlePageChange}
        totalItemsCount={totalItems}
        loading={loading}
      />
    </div>
  );
};

export default withStyles(styles, {})(memo(Audit));
